mutation CreatePortalSession($returnOrigin: String) {
  portal: StreamToolsCreatePortalSession(returnOrigin: $returnOrigin) {
    url
  }
}
